import { render, staticRenderFns } from "./travel-insurance-home-page.vue?vue&type=template&id=7993058e&scoped=true"
import script from "./travel-insurance-home-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-home-page.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-home-page.vue?vue&type=style&index=0&id=7993058e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7993058e",
  null
  
)

export default component.exports